import React from 'react';
import './BottomNav.css';
import type { PageId } from '../../types';

interface BottomNavProps {
  activePage: PageId;
  onNavigate: (page: PageId) => void;
  pendingTaskCount?: number;
}

const tabs: { id: PageId; label: string; icon: string }[] = [
  { id: 'schedule', label: 'Schedule', icon: '📋' },
  { id: 'calendar', label: 'Calendar', icon: '📅' },
  { id: 'tasks', label: 'Tasks', icon: '✏️' },
  { id: 'settings', label: 'Settings', icon: '⚙️' },
];

export const BottomNav: React.FC<BottomNavProps> = ({ activePage, onNavigate, pendingTaskCount = 0 }) => {
  const activeTab = activePage === 'customize' ? 'settings' : activePage;

  return (
    <nav className="bottom-nav">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`bottom-nav-tab ${activeTab === tab.id ? 'bottom-nav-tab--active' : ''}`}
          onClick={() => onNavigate(tab.id)}
          aria-label={tab.label}
        >
          <span className="bottom-nav-icon">
            {tab.icon}
            {tab.id === 'tasks' && pendingTaskCount > 0 && (
              <span className="bottom-nav-badge">{pendingTaskCount > 9 ? '9+' : pendingTaskCount}</span>
            )}
          </span>
          <span className="bottom-nav-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
};
